import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { ZInstagramLatestPostsResponse } from './models';

const c = initContract();

export const publicInstagramContract = c.router(
  {
    getLatestPosts: {
      method: 'GET',
      path: '/latest-posts',
      query: z.object({
        limit: z.coerce.number().int().positive().optional(),
      }),
      responses: {
        200: ZInstagramLatestPostsResponse,
        400: z.object({
          message: z.string(),
        }),
        500: z.object({
          message: z.string(),
        }),
      },
      summary: 'Get the latest Instagram posts from Daymade',
    },
  },
  {
    pathPrefix: '/public',
  },
);

export const instagramContract = c.router(
  {
    public: publicInstagramContract,
  },
  {
    pathPrefix: '/instagram',
    strictStatusCodes: true,
  },
);

export * from './models';
